/**
 * @module app.cm
 */

import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IDocumentsConfig } from 'app/core/models/essette-interfaces';
import { CasePageContext } from 'app/cm/lib/case-page-context';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { CaseChangeEvent } from 'app/cm/lib/events';


@autoinject()
export class CaseDocumentsPage extends ComponentBase {

    ////****************** Fields and Properties **************************************////
    @observable
    protected caseId: string | null = null;

    protected readonly: boolean = false;

    protected documentsConfig: IDocumentsConfig = {
        serviceRootUrl: 'cm/cases',
        targetType: 'CM.Case',
        hasTasks: true,
        addTargetProperty: (document: any /*CM.CaseDocument*/) => { document.case = { id: this.caseId } }
    };

    private subscriptions: Array<Subscription> = [];


    ////****************** Lifecycle events (in order of execution) ******************////
    constructor(
        private readonly context: CasePageContext,
        private readonly events: EventAggregator,
        ...rest: any[]) {

        super(...rest);
    }

    protected async canActivate(params: { caseId: string }): Promise<boolean> {
        if(!params.caseId) { throw new Error('Missing or invalid caseId parameter'); }

        return true;
    }

    protected async activate(params: { caseId: string }): Promise<void> {
        if(this.caseId !== params.caseId) { this.caseId = params.caseId; }

        this.checkPermissions();

        this.subscriptions.push(
            this.events.subscribe(CaseChangeEvent, (e: CaseChangeEvent) => this.handleCaseChangeEvent(e))
        );
    }

    protected deactivate(): void {
        this.subscriptions.forEach(s => s.dispose());
        this.subscriptions = [];
    }


    ////****************** Events ***************************************************////
    protected async handleCaseChangeEvent(e: CaseChangeEvent) {
        if(e.case && e.case.id === this.caseId) {
            this.checkPermissions();
        };
    }


    ////****************** Functions ***********************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        const canEditClosedCase = this.accountContext.hasPermission('CM.Case.Duty.EditClosedCase');
        this.readonly = this.context.caseIsReadOnly(canEditClosedCase);
    }
}
